import { TemplateItem } from '@anm/api/modules/templates';
import { Player } from '@anm/components/VideoPlayer';
import { useSelector } from 'react-redux';

import { templateSelectors } from '../../../store/modules/template';

import { getTemplateVideoWithPlayerRefs } from './helpers';

export const useSliderItems = () => {
  const templateList = useSelector(templateSelectors.selectTemplateList);
  const currentTemplate = useSelector(templateSelectors.selectCurrentTemplate);

  const sliderTemplateList = [
    currentTemplate,
    ...templateList.slice(0, 2)
  ].filter(Boolean) as TemplateItem[];

  const { playerRefs, sliderItems } = sliderTemplateList.reduce(
    (acc, template) => {
      const { playerRefs, sliderItems } = acc;
      const { playerRef, TemplateVideoPlayer } = getTemplateVideoWithPlayerRefs(
        template
      );

      return {
        playerRefs: [...playerRefs, playerRef.refs],
        sliderItems: [...sliderItems, TemplateVideoPlayer]
      };
    },
    {
      playerRefs: [] as Player[][],
      sliderItems: []
    }
  );

  return [sliderItems, playerRefs] as const;
};
